module.exports = __webpack_public_path__ + "img/center.03a4bba5.png";